<template>
 
  <Index/>
</template>

<script>
import Index from "@/components/index2.vue"
export default {
  name: 'AchiView',
   components: {
    Index
  },
}
</script>


<style>

</style>